import { useEffect, useRef, useState } from "react";

function convertRemToPixels(rem: number, unit: string) {
	if (unit !== "rem") {
		throw new Error(`Unknown UoM: ${unit}`);
	}

	return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
}

export const VirtualScroll: React.FC<{
	width?: number | string;
	height: number;
	unit: string;
	visibleItemCount: number;
	enabled?: boolean;
	children: Array<React.ReactElement>;
}> = ({ width, height, unit, visibleItemCount, enabled, children: items }) => {
	const { scrollable } = useStyles();
	const outerRef = useRef<HTMLDivElement | null>(null);
	const innerRef = useRef<HTMLDivElement | null>(null);
	const [firstElementIndex, setFirstElementIndex] = useState(0);
	const [firstElementOffset, setFirstElementOffset] = useState(0);
	const visibleElements = items.slice(firstElementIndex, firstElementIndex + visibleItemCount + 1);
	const elementHeight = convertRemToPixels(height / visibleItemCount, unit);

	function handleScroll() {
		if (!outerRef.current || !innerRef.current || !items.length) {
			return;
		}

		setFirstElementIndex(Math.floor((outerRef.current.scrollTop / outerRef.current.scrollHeight) * items.length));
		setFirstElementOffset(outerRef.current.scrollTop % elementHeight);
	}

	useEffect(() => {
		handleScroll();
	}, [outerRef.current, innerRef.current]);

	if (!enabled) {
		return <>{items}</>;
	}

	return (
		<div ref={outerRef} className={scrollable} style={{ width, height: `${height}${unit}` }} onScroll={handleScroll}>
			<div ref={innerRef} style={{ position: "relative", width: "100%", height: elementHeight * items.length, overflow: "hidden" }}>
				{visibleElements.map((element, index) => (
					<div
						key={firstElementIndex + index}
						style={{
							position: "absolute",
							left: 0,
							width: "100%",
							top: (outerRef.current?.scrollTop || 0) - firstElementOffset + index * elementHeight,
						}}
					>
						{element}
					</div>
				))}
			</div>
		</div>
	);
};

import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
	scrollable: {
		overflowY: "auto",
	},
}));
